module.exports = __webpack_public_path__ + "static/img/24341.6a41a2fa.png";